import { isOnServer } from './isOnServer';

/**
 * Detects if browser supports passive events
 * https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */
let supportsPassiveEvents = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: void function() {
      supportsPassiveEvents = true;
    },
  });
  if (!isOnServer) {
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  }
} catch (e) {
  console.log('\n\nCAUGHT\n\n');
}

export { supportsPassiveEvents };
